module.exports = __webpack_public_path__ + "img/Malta.ffddf32f.svg";